import React from 'react';
import PropTypes from 'prop-types';

import {
  FacebookShareButton,
  WhatsappShareButton,
  FacebookIcon,
  WhatsappIcon,
} from 'react-share';
import styles from './ShareButtons.module.css';

export default function ShareButtons({
  display = false,
  url = '',
  title = '',
  size = '2.5em',
}) {
  if (display) {
    return (
      <div className={styles.shareContainer}>
        <div className={styles.shareIconContainer}>
          <FacebookShareButton url={url} quote={title}>
            <FacebookIcon className={styles.shareIcon} size={size} />
          </FacebookShareButton>
        </div>

        <div className={styles.shareIconContainer}>
          <WhatsappShareButton url={url} title={title}>
            <WhatsappIcon className={styles.shareIcon} size={size} />
          </WhatsappShareButton>
        </div>
      </div>
    );
  }

  return <></>;
}

ShareButtons.propTypes = {
  display: PropTypes.bool,
  url: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.string,
};
